import React from 'react';
import Slider, { Settings as ISliderProps } from 'react-slick';

import { IMedia } from './types';
import { CarouselArrow, EDirection } from './components/CarouselArrow';
import { CarouselElement } from './components/CarouselElement';
import { CarouselPagination, CarouselPaginationBullet } from './components/CarouselPagination';

import './3rdParty/slick.css';
import './3rdParty/slick-theme.css';
import * as styles from './Carousel.css';

export interface ICarouselProps extends Omit<ISliderProps, 'prevArrow' | 'nextArrow'> {
  media: IMedia[];
  className?: string;
  onClick?(): void;
}

interface ICarouselState {
  currentSlide: number;
  nextSlide: number;
}

export class Carousel extends React.Component<ICarouselProps, ICarouselState> {
  private sliderRef = React.createRef<Slider>();

  public state = {
    currentSlide: this.props.initialSlide || 0,
    nextSlide: this.props.initialSlide || 0,
  };

  public get currentSlide() {
    return this.state.currentSlide;
  }

  public goToSlide = (index: number) => {
    /* istanbul ignore else */
    if (this.sliderRef && this.sliderRef.current) {
      this.sliderRef.current.slickGoTo(index);
    }
  };

  public render() {
    const { media, onClick, className, lazyLoad, ...sharedProps } = this.props;
    const { currentSlide, nextSlide } = this.state;

    return (
      <div className={styles['container']} onClick={onClick}>
        <Slider
          {...sharedProps}
          ref={this.sliderRef}
          dots
          speed={200}
          lazyLoad={lazyLoad}
          appendDots={dots => (
            <CarouselPagination count={media.length} active={nextSlide}>
              {dots}
            </CarouselPagination>
          )}
          customPaging={i => <CarouselPaginationBullet active={nextSlide} index={i} count={media.length} />}
          swipe={false}
          prevArrow={<CarouselArrow direction={EDirection.Left} />}
          nextArrow={<CarouselArrow direction={EDirection.Right} />}
          afterChange={this.handleAfterChange}
          beforeChange={this.handleBeforeChange}
        >
          {media.map((m, index) => (
            <CarouselElement key={`slide_${index}`} media={m} isActive={currentSlide === index} />
          ))}
        </Slider>
      </div>
    );
  }

  private handleBeforeChange = (_: number, index: number) => {
    this.setState(prev => ({
      ...prev,
      nextSlide: index,
    }));
  };

  private handleAfterChange = (index: number) => {
    this.setState(
      {
        currentSlide: index,
      },
      () => {
        /* istanbul ignore else */
        if (this.props.afterChange) {
          this.props.afterChange(index);
        }
      },
    );
  };
}
